'use client';

import { FC, useEffect, useState } from 'react';
import { useClassName } from '../../../hooks/use-class-name';
import { OwShelf } from '../../../interfaces/domain/ow-app-shelf.modal';
import SpriteIcon from '../../shared/sprite-icon';
import { useTranslation } from '../../../hooks/use-translation';
import useIsMobile from '../../../hooks/use-is-mobile';
import BannersShelveItem from './banners-shelve-item';
import { OwBannerImage } from '../../../interfaces/domain/ow-banner.modal';
import OWLink from '../../shared/ow-link';
// -----------------------------------------------------------------------------
interface BannersShelveProps {
  bannersData: OwShelf;
}
// -----------------------------------------------------------------------------

const BannersShelve: FC<BannersShelveProps> = props => {
  const {
    children,
    layoutStyle,
    title,
    showViewAll,
    mobileLimit,
  } = props.bannersData;

  const { t } = useTranslation();

  const sectionClassName = useClassName({
    'top-games': layoutStyle
  }, 'games-list-section');

  const [limit, setLimit] = useState(
    mobileLimit ? mobileLimit : children?.length ?? 0
  );

  const [visibleBanners, setBanners] = useState(
    children?.slice(0, limit) ?? []
  );

  const isMobile = useIsMobile();

  // ---------------------------------------------------------------------------
  useEffect(() => {
    if (!isMobile) {
      setBanners(children ?? []);
    };
  }, []);
  // ---------------------------------------------------------------------------

  if (!children) {
    return null;
  }
  // ---------------------------------------------------------------------------

  const handleLoadMore = (): void => {
    const newLimit = limit + 10;
    setBanners(children?.slice(0, newLimit) ?? []);
    setLimit(newLimit);
  };
  // ---------------------------------------------------------------------------

  return (
    <section className={sectionClassName}> 
      <div className='game-list-inner'>

        {title &&
          <h2>{title}</h2>
        }

        <div className='games-list-wrapper'>
          <ul className='games-list'>
            {visibleBanners.map((item, index) => {
              return (
                <BannersShelveItem
                  item={item as OwBannerImage} 
                  key={index}
                />
              );
            })}
          </ul>
        </div>

        {showViewAll &&
          <OWLink
            className='btn-secondary icon view-all'
            href='/browse-by-game/view-all'
          >{t('viewAll')}
            <SpriteIcon icon='arrowRight' />
          </OWLink>
        }

        {!layoutStyle && limit < children.length &&
          <div className='games-list-actions'>
            <p className='desc'>
              {t('allGamesActions',
                { shown: limit.toString(), max: children.length.toString() })}
            </p>
            <button 
              className='btn-secondary-small show-more'
              onClick={handleLoadMore}
            >
              {t('loadMore')}
            </button>
          </div>
        }

      </div>
    </section>
  );
};

export default BannersShelve;